import createAsyncAction from "utils/createAsyncAction";
import { readRevisionAsync } from "actions/items";
import { hydrateFormUtils, initializeForm } from "editor/actions/form";
import { saveForm } from "editor/actions/status";

export const GET_REVISIONS_LIST_REQUESTED = "GET_REVISIONS_LIST_REQUESTED";
export const GET_REVISIONS_LIST_SUCCEEDED = "GET_REVISIONS_LIST_SUCCEEDED";
export const GET_REVISIONS_LIST_FAILED = "GET_REVISIONS_LIST_FAILED";

export const getRevisionsListAsync = id => (dispatch, getState, getClient) => {
  const {
    editor: {
      status: {
        editorType: { name },
      },
    },
  } = getState();

  return createAsyncAction(name, "revisionList", "GET_REVISIONS_LIST")(id)(
    dispatch,
    getState,
    getClient
  );
};

/**
 * Given a revision ID, fetch the article, and populate the form.
 * @param {string} id story ID
 */
export const revertToRevision = (id, revisionId, head_rev) => {
  return dispatch => {
    return dispatch(readRevisionAsync(id, revisionId))
      .then(action => {
        const story = action.payload;
        const storyWithHeadRev = { ...story, head_rev };
        return dispatch(initializeForm(hydrateFormUtils(storyWithHeadRev)));
      })
      .then(() => {
        return dispatch(saveForm());
      });
  };
};
